export default "__VITE_ASSET__DfBzd5sq__"